import { render } from "./VChangeIndicator.vue?vue&type=template&id=3124e3d4&scoped=true&bindings={\"oldValue\":\"props\",\"newValue\":\"props\",\"percentage\":\"props\",\"decimals\":\"props\",\"isDecrease\":\"data\",\"isOpposite\":\"data\",\"showOpposite\":\"options\"}"
import script from "./VChangeIndicator.vue?vue&type=script&lang=js"
export * from "./VChangeIndicator.vue?vue&type=script&lang=js"

import "./VChangeIndicator.vue?vue&type=style&index=0&id=3124e3d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3124e3d4"

export default script